import getLogger from '@ignitesales/logger-es';
import React from 'react';
import {Provider} from 'react-redux';
import {IntlProvider} from 'react-intl';
import {QuestionLayoutContext, QuestionTypeContext} from './components/questions/QuestionComponentContext.mjs';
import {TextContextProvider} from './components/TextContext';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import PropTypes from 'prop-types';

const logger = getLogger({component: 'NeuroRoot'});

// we are using class here so we can attach error boundary behavior on this root node
// this is not currently possible using function + hooks
class NeuroRoot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error, errorInfo) {
    logger.error('NeuroRoot caught error', {error, errorInfo});
  }

  render() {
    const {AppComponent, locale, mainStore, messages, questionLayouts, questionTypes} = this.props;

    return (
      <Provider store={mainStore}>
        <IntlProvider locale={locale} messages={messages[locale]} wrapRichTextChunksInFragment>
          <QuestionTypeContext.Provider value={questionTypes}>
            <QuestionLayoutContext.Provider value={questionLayouts}>
              <TextContextProvider>
                <Router>
                  <Route component={AppComponent} />
                </Router>
              </TextContextProvider>
            </QuestionLayoutContext.Provider>
          </QuestionTypeContext.Provider>
        </IntlProvider>
      </Provider>
    );
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }
}

NeuroRoot.propTypes = {
  AppComponent: PropTypes.any,
  locale: PropTypes.string,
  mainStore: PropTypes.object,
  messages: PropTypes.any,
  questionLayouts: PropTypes.any,
  questionTypes: PropTypes.any,
  isBranchGuide: PropTypes.bool,
};
export default NeuroRoot;
